class MaterialPillsBar extends HTMLElement {
  connectedCallback() {
    this.FILTER_KEY = this.dataset.filterParam || 'filter.p.m.custom.strap_material';
    this.pills = this.querySelectorAll('.material-pill');
    this.pills.forEach((pill) => pill.addEventListener('click', this.onPillClick.bind(this)));

    this.syncActiveStates(window.location.search.slice(1));

    window.addEventListener('popstate', () => {
      this.syncActiveStates(window.location.search.slice(1));
    });

    this.waitForFacets();
  }

  waitForFacets() {
    if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.renderPage) {
      this.patchFacetRenderPage();
      return;
    }
    const observer = new MutationObserver(() => {
      if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.renderPage) {
        observer.disconnect();
        this.patchFacetRenderPage();
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(() => {
      observer.disconnect();
      if (typeof FacetFiltersForm !== 'undefined') this.patchFacetRenderPage();
    }, 3000);
  }

  patchFacetRenderPage() {
    if (this._patched) return;
    this._patched = true;
    const pillsBar = this;
    const originalRenderPage = FacetFiltersForm.renderPage;
    FacetFiltersForm.renderPage = function (searchParams, event, updateURLHash) {
      originalRenderPage.call(this, searchParams, event, updateURLHash);
      pillsBar.syncActiveStates(searchParams);
    };
  }

  onPillClick(event) {
    event.preventDefault();
    const pill = event.currentTarget;
    const type = pill.dataset.pillType;
    const value = pill.dataset.pillValue;

    const params = new URLSearchParams(window.location.search);

    if (type === 'sort') {
      if (params.get('sort_by') === value) {
        params.delete('sort_by');
      } else {
        params.set('sort_by', value);
      }
    } else {
      // Single-select: clear all tag filters from pills, then toggle
      const currentValues = params.getAll(this.FILTER_KEY);
      const isActive = currentValues.includes(value);
      params.delete(this.FILTER_KEY);

      if (!isActive) {
        params.append(this.FILTER_KEY, value);
      }
    }

    params.delete('page');

    const searchParamsString = params.toString();

    if (typeof FacetFiltersForm !== 'undefined') {
      FacetFiltersForm.renderPage(searchParamsString);
    } else {
      window.location.search = '?' + searchParamsString;
    }

    this.syncActiveStates(searchParamsString);
  }

  syncActiveStates(searchString) {
    const params = new URLSearchParams(searchString || '');
    const activeTags = params.getAll(this.FILTER_KEY);
    const activeSort = params.get('sort_by');

    this.pills.forEach((pill) => {
      const type = pill.dataset.pillType;
      const value = pill.dataset.pillValue;

      if (type === 'sort') {
        pill.classList.toggle('material-pill--active', activeSort === value);
      } else {
        pill.classList.toggle('material-pill--active', activeTags.includes(value));
      }
    });
  }
}

customElements.define('material-pills-bar', MaterialPillsBar);
